import { CancelOutlined } from "@mui/icons-material";
import { Box, Dialog } from "@mui/material";
import React from "react";
import { Input } from "../../components/Input";
import Grid from "@mui/material/Grid2";
import style from "./login.module.css";
export default function Login({ loginDialog, setLoginDialog }) {
  return (
    <Dialog open={loginDialog} maxWidth="sm" fullWidth={true}>
      <Box p={1} pb={0} className="text-end">
        <CancelOutlined
          className="pointer"
          onClick={() => {
            setLoginDialog(false);
          }}
        />
      </Box>
      <Box sx={{ p: 3, pt: 0 }}>
        <div className="d-flex justify-content-center mt-3">
          <div className={style.heading}>Login your account</div>
        </div>
        <Grid container spacing={1} className="mt-3">
          <Grid size={{ lg: 12, md: 12, sm: 12 }}>
            <label className={style.label}>
              Email<span className="text-danger">*</span>
            </label>
            <Input
              placeholder="Enter your email"
              required
              type="email"
              name="email"
            />
          </Grid>
          <Grid size={{ lg: 12, md: 12, sm: 12 }}>
            <label className={style.label}>
              Password<span className="text-danger">*</span>
            </label>
            <Input
              placeholder="Enter your email"
              required
              type="password"
              name="password"
            />
          </Grid>
        </Grid>
        <div className="d-flex justify-content-center mt-4">
          <button
            type="submit"
            //   disabled={!checkAgreement}
            className={style.login_btn}
            // onClick={() => {
            //   checkValidation();
            // }}
          >
            Login
          </button>
        </div>
      </Box>
    </Dialog>
  );
}
